import { render, staticRenderFns } from "./CardCanvas.vue?vue&type=template&id=1d10dc12&scoped=true&"
import script from "./CardCanvas.vue?vue&type=script&lang=js&"
export * from "./CardCanvas.vue?vue&type=script&lang=js&"
import style0 from "./CardCanvas.vue?vue&type=style&index=0&id=1d10dc12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d10dc12",
  null
  
)

export default component.exports